import type { FaireProductEntity } from "../../entity_types/product";

export const p_3tuhu2tp5g: FaireProductEntity = {
  token: "p_3tuhu2tp5g",
  type: "product",
  name: "Two Tone 18K Gold Plated Stainless Steel Chain Necklace -FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/920599a95404f711c75354607761b0e5c88c89e4249b985802a896b185553918.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bdb39cc8ce66bdb7b1e0877d04fa3cb2829c23170dfaa1d7a7d335ee79457810.jpeg",
    "https://cdn.faire.com/fastly/c0570d9bffaed3fbec4601047a6f1bca395b9ae9fca43a7fd7f2c268037307ff.jpeg",
  ],
  priceDollars: 11.24,
  description:
    "Type: Pendant necklace\nMaterial: Stainless steel，18K gold plated\nWidth - 4.4mm\nLength : 400mm + 50mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 28.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:07.269Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
